
<style>
  .section{
    background-color:transparent !important;
  }
</style>
<template >



  <div class="container">
    <h3 class="font-weight-bold mb-4 centers" style="margin-top: 165px;">Nos combats</h3>
    <div
      v-for="(besoin) in besoins"
      :key="besoin.id"
      class="container"
    >
      <div class="row margetop" :id="besoin.titre.toLowerCase().replace(/\s+/g, '-')">
        
        <!-- Cas pair : image à gauche, texte à droite -->
      
          <div class="col-lg-5" :style="{ marginTop: '50px' }">
            <img
              class="test"
              :src="`https://admin.asso-refuge.fr/images/${besoin.img}`"
              :alt="besoin.titre"
            />
          </div>
              <div class="col-lg-1"></div>
          <div class="col-lg-5" :style="{ marginTop: '50px' }">
            <h3 class="font-weight-bold mb-4 justus">{{ besoin.titre }}</h3>
            <div v-html="besoin.content"></div>
          </div>

      </div>
    </div>
  </div>
</template>

<style src="../assets/css/besoin.css"></style>


<script>
export default {
  data() {
    return {
      besoins: [],
    };
  },
  methods: {
    decodeHtmlEntities(text) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }
  },
mounted() {
  const idSite = this.$idSite;
  fetch(`https://admin.asso-refuge.fr/getCombats/${idSite}`)
    .then(response => response.json())
    .then(data => {
      // Décodage et suppression des attributs onload
      let formattedBesoins = data.map(besoin => {
        const content = this.decodeHtmlEntities(besoin.content)
          .replace(/onload="[^"]*"/gi, ''); // supprime tout attribut onload
        return { ...besoin, content };
      });

      // Trier par ID croissant
      formattedBesoins.sort((a, b) => a.id - b.id);

      // Réorganiser : id 59 en premier, id 58 en dernier
      const index59 = formattedBesoins.findIndex(b => b.id === 59);
      if (index59 !== -1) {
        const [bloc59] = formattedBesoins.splice(index59, 1);
        formattedBesoins.unshift(bloc59);
      }

      const index58 = formattedBesoins.findIndex(b => b.id === 58);
      if (index58 !== -1) {
        const [bloc58] = formattedBesoins.splice(index58, 1);
        formattedBesoins.push(bloc58);
      }

      this.besoins = formattedBesoins;
    })
    .catch(error => {
      console.error('Il y a eu un problème avec votre requête :', error.message);
    });
}
};
</script>